import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { PDP_CUSTOMIZE_TAB_ID, PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import CtaButton from 'components/essentials/Cta/CtaButton';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useProductEFGInternalStatus from 'data-hooks/useProductEFGInternalStatus';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPOptions from '../state/context/usePDPOptions';
import usePdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import useSetPdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';

// Decide Later leaves the tab bar in the layout revamp; mirrors the conditions
// PDPShopTabsBar applies to the tab item it replaces
const PDPDecideLaterButtonInner = t0 => {
  const $ = _c(10);
  const {
    className: t1,
    isEditOrder: t2
  } = t0;
  const className = t1 === undefined ? "mt-4" : t1;
  const isEditOrder = t2 === undefined ? false : t2;
  const {
    data: t3
  } = usePDPOptions();
  const {
    upholsteryOptionId
  } = t3 === undefined ? {} : t3;
  const {
    isEFGInternal
  } = useProductEFGInternalStatus();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  if (isEditOrder || isEFGInternal || !upholsteryOptionId) {
    return null;
  }
  const isActive = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const price = basicDetails?.meta?.price;
  const promoText = price?.max_discount_percent ? ` (lock in up to ${price.max_discount_percent}% off)` : price?.discount_percent ? ` (lock in ${price.discount_percent}% off)` : "";
  const t4 = isActive ? "solid-button" : "outline-button";
  let t5;
  if ($[0] !== isActive || $[1] !== setPdpSelectedCustomizerTab) {
    t5 = () => setPdpSelectedCustomizerTab(isActive ? PDP_CUSTOMIZE_TAB_ID : PDP_DECIDELATER_TAB_ID);
    $[0] = isActive;
    $[1] = setPdpSelectedCustomizerTab;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = isActive ? "Choose a fabric now" : `Decide Later${promoText}`;
  let t7;
  if ($[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = <CtaButton block={true} color="brand" spacing="sm" styling={t4} onClick={t5}>{t6}</CtaButton>;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== className || $[8] !== t7) {
    t8 = <div className={className} data-xc="PDPDecideLaterButton">{t7}</div>;
    $[7] = className;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};
PDPDecideLaterButtonInner.propTypes = {
  className: PropTypes.string,
  isEditOrder: PropTypes.bool
};
const PDPDecideLaterButton = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPDecideLaterButtonInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPDecideLaterButton;